import FollowButton from './FollowButton';
export default FollowButton;